import { Component, ViewChild, ElementRef, HostListener, Renderer2, Inject, ChangeDetectorRef, ViewContainerRef, ComponentRef } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import swal from 'sweetalert2';
import { Meta, Title } from '@angular/platform-browser';
import { ApidataService } from '../apidata.service';
import { HeaderComponent } from "../header/header.component";
import { FooterComponent } from '../footer/footer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule, HttpHeaders, } from '@angular/common/http';
import { Router, NavigationEnd } from '@angular/router';

import { RouterModule } from '@angular/router';
import { filter } from 'rxjs/operators';
import { MetaTagService } from './../meta-tag.service';
import { environment, GINConstants } from '../../environments/environments';
import { FeedbackComponent } from '../feedback/feedback.component';
import { IconsFreeToolsComponent } from '../icons-free-tools/icons-free-tools.component';
import { QuillModule } from 'ngx-quill';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import Quill from "quill";
import { PremiumComponent } from "../premium/premium.component";
import { PremiumModalStartupComponent } from '../premium-modal/premium-modal.component';

declare var Dropbox: any;
declare var $: any;
declare var window: any;
declare var gapi: any;
declare var google: any;

@Component({
    selector: 'app-sentence-checker',
    standalone: true,
    imports: [HeaderComponent, CommonModule, FormsModule, ReactiveFormsModule, HttpClientModule,
    FooterComponent, RouterModule, FeedbackComponent, IconsFreeToolsComponent, QuillModule, PremiumComponent,
    PremiumModalStartupComponent,
  ],
    templateUrl: './sentence-checker.component.html',
    styleUrl: './sentence-checker.component.css'
})
export class SentenceCheckerComponent {
    recaptcha_message = ""
    got_recpatcha: boolean = false;
    hoveredIndex: number | null = null;
    activeStep: number = 3;

    onHover(index: number): void { this.hoveredIndex = index; this.activeStep = index; }

    onLeave(): void { this.hoveredIndex = null; this.activeStep = 3; }
    captchaToken: string | null = null;
    selectenglishlanguage: boolean = true
    editorTxtAI: string;
    activeTab: string = '';
    showonlydrive: boolean = false;
    spellingmistake = 0;
    garmmarmistake = 0;
    stars: number[] = [1, 2, 3, 4, 5];
    count = 5;
    color: string = 'black';
    form_message: any;
    form_email: any;
    showfeedbackloader: boolean = false;
    esubText: string = '';
    esubText2: string = '';
    selectedValue: number;
    eFsubText2: any;
    eFsubIF: boolean = false;
    char_count = 0;
    word_count = 0;
    gotresponse: boolean = false;
    editortext = '';
    showbuttons: boolean = false;
    loaderAlert: boolean = false;
    menuafterresponse: boolean = false;
    copiedtext: boolean = false;
    copried_txt: string = '';
    EdittorHeight: any;
    EdittorWidth: any;
    error: boolean = false;
    errorAlerts;
    success: boolean = false;
    successAlert;
    ifsub: boolean = false;
    dangerAlerts;
    profile_id;
    editortxt = '';
    subscribed_user;
    checkLogin = false;
    mobilescreen: boolean = false;
    responseformodbile: boolean = false;
    isMenuDropdownVisible = false;
    shouldShowButton: boolean = false;
    selectedLanguage = { name: 'British', icon: '../../assets/images/flag/British.svg', };
    homeText = '';
    doc_id = '';

    languages = [
        { name: 'British', icon: '../../assets/images/flag/British.svg' },
        { name: 'American', icon: '../../assets/images/flag/American.svg' },
        { name: 'Canadian', icon: '../../assets/images/flag/Canadian.svg' },
        {
            name: 'Australian', icon: '../../assets/images/flag/Australian.svg'
        },
    ];

    constructor(private renderer: Renderer2, @Inject(DOCUMENT) private documenta: Document, private webservices: ApidataService,
     private el: ElementRef, private router: Router, private https: HttpClient, private sanitizer: DomSanitizer,
        private metaService: MetaTagService, private cdr: ChangeDetectorRef, private viewContainerRef: ViewContainerRef,
    ) {
        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe(() => {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            });
    }

    public title: any;
    public description: any;
    private scriptElement: HTMLScriptElement | undefined;
    ngOnInit(): void {

        this.metaService.updateTags("Sentence Checker (100% Free) - GrammarIn",
            "GrammarIn's sentence checker is a free writing assistant that makes your sentence grammatically correct by reviewing it for clarity, style, and word choice.",
            "https://www.grammarin.com/sentence-checker",
            "https://www.grammarin.com/assets/images/OG-Images/sentence-checker.png",
            'Sentence Checker');
            this.char_count = $('#editor').text().length;
            this.homeText = $('#editor').text();
            this.word_count = $('#editor').text().split(/\s+/).length;

        $('.tab_content').hide();
        $('.tab_content:first').show();


        $('ul.tabs li').click(function () {
            $('.tab_content').hide();
            var activeTab = $(this).attr('rel');
            $('#' + activeTab).fadeIn();

            $('ul.tabs li').removeClass('active');
            $(this).addClass('active');

            $('.tab_drawer_heading').removeClass('d_active');
            $(".tab_drawer_heading[rel^='" + activeTab + "']").addClass('d_active');

        });
        $('.tab_container').css('min-height', function () {
            return $('.tabs').outerHeight() + 50;
        });

        $('.tab_drawer_heading').click(function () {
            $('.tab_content').hide();
            var d_activeTab = $(this).attr('rel');
            $('#' + d_activeTab).fadeIn();

            $('.tab_drawer_heading').removeClass('d_active');
            $(this).addClass('d_active');

            $('ul.tabs li').removeClass('active');
            $("ul.tabs li[rel^='" + d_activeTab + "']").addClass('active');
        });

        this.activeTab = 'q1';
        this.textfromAI();
    }

    ngOnDestroy(): void {
        if (this.scriptElement) {
            this.renderer.removeChild(this.documenta.head, this.scriptElement);
        }
    }
    toggleTab(tabId: string): void {
        if (this.activeTab === tabId) {
            this.activeTab = '';
        } else {
            this.activeTab = tabId;
        }
    }
    selectedTab: string = 'tab1';
    selectTab(tab: string): void {

        this.selectedTab = tab;
    }
    selectTabImg(tab: string): void {

        this.selectedTab = tab;
    }

    textfromAI() {
        if (localStorage.getItem('editorValueAI')) {
            this.showParagraph = false;
        }
        setTimeout(() => {
            if (localStorage.getItem('editorValueAI')) {
                this.editorTxtAI = localStorage.getItem('editorValueAI');
                this.char_count = this.editorTxtAI.length;
                this.word_count = this.editorTxtAI.trim().split(/\s+/).length;
                localStorage.removeItem('editorValueAI');

                if (this.editorTxtAI != null && this.editorTxtAI.length !== 0) {
                    this.textDivRef.nativeElement.innerHTML = this.editorTxtAI;
                }
            }
        }, 1000);
    }

   

    sampletext() {
        const newText = "We all are aware of the fact that plagiarism can destroy our careers and websites' credibility. Suppose you have detected that some proportion of your text is plagiarized. In that case, you can opt to use the best article rewriter to make your plagiarized sentences and display their plagiarism-free version in a matter of seconds. It means that it's not only wasted an hour or more trying to rewrite plagiarism from the text yourself and then putting to some responsibility for both of these demanding jobs and providing you 100% unique content in the blink of an eye. There is plagiarism, but only some platforms will provide you with the quality Grammarin offers. This article is jam-packed with top-notch features to facilitate you in the best way possible. You can enjoy the following features."
      
        if (this.quill) {
          this.quill.root.innerHTML = newText; 
        }
      
        this.homeText = newText; 
      
        setTimeout(() => {
          this.char_count = this.quill.getText().length;
          this.word_count = this.quill.getText().trim().split(/\s+/).length;
        }, 100);
        this.showParagraph = false;
      }

    // SCROL
    @HostListener('window:scroll', [])
    onWindowScroll() {
        if (window.pageYOffset > 200) {
            this.shouldShowButton = true;
        } else {
            this.shouldShowButton = false;
        }
    }
    scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }
    //


    showParagraph: boolean = true;
    @ViewChild('text') text: ElementRef;

    isPopupOpen = false;
    clientId =
        '859452103362-3aroha97qk7nt8ps6ocl70k10pj7uuvt.apps.googleusercontent.com';
    scope = [
        'profile',
        'email',
        'https://www.googleapis.com/auth/drive.file',
    ].join(' ');
    pickerApiLoaded = false;
    oauthToken?: any;
    @ViewChild('fileInput') fileInput;
    @ViewChild('editor') editor!: ElementRef<HTMLDivElement>;

    showAlert(message, selector) {
        this.errorAlerts = message;
        $(selector).css('border-color', 'red');
        this.error = true;
        $('#errorAlerts').show();
        setTimeout(() => {
            $('#errorAlerts').hide();
            $(selector).css('border-color', '#e7e7ec');
            this.error = false;
        }, 4000);

    }

    showSuccess(message, selector) {
        this.successAlert = message;
        this.success = true;
        $('#successAlert').show();
        setTimeout(() => {
            $('#successAlert').hide();
            $(selector).css('border-color', '#e7e7ec');
            this.success = false;
        }, 4000);
    }

    closeErrorDiv() {
        this.error = false;
    }

    getElementHeightById(id: string): void {
        const element = this.el.nativeElement.querySelector(`#${id}`);
        if (element) {
            this.EdittorHeight = element.clientHeight;
            this.EdittorWidth = element.clientWidth;

        } else {

        }
    }

    uploadFileSaveRedirect(event): void {
        $('#UpFileModal').modal({
            backdrop: 'static',
            keyboard: false
        });

        const files: FileList = this.fileInput.nativeElement.files;

        var filetype = 'pdf';
        if (files[0].size > 5243000) {
            this.showAlert('File should be less than 5 MB.', '');
        } else {
            let input = event.target;
            this.menuafterresponse = false;
            this.gotresponse = false;
            this.loaderAlert = true;
            this.showParagraph = true;
            this.char_count = 0;
            this.showbuttons = false;
            this.showParagraph = false;
            // var testingnew = document.getElementById('editor');
            // if (testingnew.textContent != 'vv') {
            //     testingnew.textContent = '';
            // }

            $('.hideUpload').hide('slow');
            this.webservices.uploadfilefrombrowser(files).subscribe(
                (data) => {
                    this.loaderAlert = false;
                    let receivedData = data;
                    $(".ql-editor").html(
                        receivedData['RetCnt']
                            .replace(/&quot;/g, '"')
                            .replace(/&#x27;/g, "'")
                            .replace(/&amp;/g, /&/g)
                            .replace(/&gt;/g, '>')
                            .replace(/&lt;/g, '<')
                            .replace(/&quot;/g, /"/g)
                    );
                    this.getContent('', receivedData['RetCnt']);
                    this.fileInput.nativeElement.value = '';
                    // }
                },
                (error) => {
                    this.loaderAlert = false;
                    this.showAlert(
                        'Unable to proceed with a password protected file.',
                        ''
                    );
                }
            );
        }
    }
    /// dropbox  gDriveUpload functionn
  
    public gDriveUpload() {
      gapi.load('auth', { callback: this.onAuthApiLoad.bind(this) });
      gapi.load('picker', { callback: this.onPickerApiLoad.bind(this) });
      setTimeout(() => {
        $('.ql-editor').click(); 
      }, 500);
    
    }
  
    public onAuthApiLoad() {
      gapi.auth.authorize(
        {
          client_id: this.clientId,
          scope: this.scope,
          immediate: false,
        },
        this.handleAuthResult
  
      );
     
      setTimeout(() => {
        $('.ql-editor').click(); 
      }, 500);
    }
  
    public onPickerApiLoad() {
      this.pickerApiLoaded = true;
    }
  
    public handleAuthResult(authResult) {
      $('#UpFileModal').modal('hide');
      let src;
  
      if (authResult && !authResult.error) {
        if (authResult.access_token) {
          let view = new google.picker.View(google.picker.ViewId.DOCS);
          view.setMimeTypes(
            'application/pdf,application/txt,text/plain,application/vnd.oasis.opendocument.text,application/vnd.google-apps.document,application/vnd.openxmlformats-officedocument.wordprocessingml.document'
          );
  
          let pickerBuilder = new google.picker.PickerBuilder();
          let picker = pickerBuilder
            .enableFeature(google.picker.Feature.MINE_ONLY)
            .setOAuthToken(authResult.access_token)
            .addView(view)
            .addView(new google.picker.DocsUploadView())
            .setCallback(function (e) {
              if (e.action == google.picker.Action.PICKED) {
                var fileId = e.docs[0].id;
                var file = e.docs[0].url;
                var files = e.docs[0];
                if (files.sizeBytes > 5243000) {
                  this.lodershow = false;
  
                  swal({
                    background: '#FFFFFF',
                    title: 'Error',
                    html: `
                    <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
                      background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
                      <div class="text-center" style="margin-top: 9%;">
                        <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
                        <div style="width: 323px; height: 64px; margin-left: 77px;">
                          <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                            File should be less than 5 MB
                          </p>
                        </div>
                        <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
                          border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
                          class="mt-4 butn-alert">Ok</button>
                      </div>
                    </div>
                  `,
                    showConfirmButton: false,
                    width: '323px',
                    timer: 4000,
                  });
  
                  setTimeout(() => {
                    const okButton = document.getElementById('swal-ok-button');
                    if (okButton) {
                      okButton.addEventListener('click', () => {
                        swal.close();
                      });
                    }
                  }, 0);
                } else {
                  if (e.docs[0].name.split('.')[1] === 'pdf') {
                    let filelink2 = file + fileId;
                    let linksvalue =
                      'https://drive.google.com/u/0/uc?id=' +
                      fileId +
                      '&export=download';
                    let profile_id = localStorage.getItem('profile_id');
                    $.ajax({
                      url: environment.API_URL + '/api/downloadFromDrive',
                      type: 'post',
  
                      dataType: 'json',
                      data: {
                        profile_id: profile_id,
                        hash: authResult.access_token,
                        file_path: fileId,
                        file_type: 'pdf',
                        create_chunks: 'false',
                      },
                      beforeSend: function (xhr) {
                        xhr.setRequestHeader(
                          'Authorization',
                          +localStorage.getItem('token')
                        );
                      },
  
                      success: function (return_data) {
                        $('.ql-editor').html(
                          return_data.RetCnt.replace(/&quot;/g, '"')
                            .replace(/&#x27;/g, "'")
                            .replace(/&amp;/g, /&/g)
                            .replace(/&gt;/g, '>')
                            .replace(/&lt;/g, '<')
                            .replace(/&quot;/g, /"/g)
                        );
                        this.homeText = return_data.RetCnt;
                         
                       
                        setTimeout(() => {
                          $('.ql-editor').click(); 
                        }, 500);
                      },
                      error: function (data) {
                        swal({
                          background: '#FFFFFF',
                          title: 'Error',
                          html: `
        <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
          background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
          <div class="text-center" style="margin-top: 9%;">
            <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
            <div style="    width: 369px; height: 64px; margin-left: 39px;">
              <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                This file is restricted. Update the public access of your file from \"Restricted\" to \"Anyone with the link.\"
              </p>
            </div>
            <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
              border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
              class="mt-5 butn-alert">Ok</button>
          </div>
        </div>
      `,
                          showConfirmButton: false,
                          width: '323px',
                          timer: 4000,
                        });
  
                        setTimeout(() => {
                          const okButton =
                            document.getElementById('swal-ok-button');
                          if (okButton) {
                            okButton.addEventListener('click', () => {
                              swal.close();
                            });
                          }
                        }, 0);
                      },
                    });
                  } else if (e.docs[0].name.split('.')[1] === 'txt') {
                    let filelink2 = file + fileId;
                    let linksvalue =
                      'https://drive.google.com/u/0/uc?id=' +
                      fileId +
                      '&export=download';
  
                    if (localStorage.getItem('profile_id')) {
                      var profile_id = localStorage.getItem('profile_id');
                    } else {
                      var profile_id = '1';
                    }
                    $.ajax({
                      url: environment.API_URL + '/api/downloadFromDrive',
                      type: 'post',
  
                      dataType: 'json',
                      data: {
                        profile_id: profile_id,
                        hash: authResult.access_token,
                        file_path: fileId,
                        file_type: 'txt',
                        create_chunks: 'false',
                      },
                      beforeSend: function (xhr) {
                        xhr.setRequestHeader(
                          'Authorization',
                          +localStorage.getItem('token')
                        );
                      },
  
                      success: function (return_data) {
                        this.hideothers = true;
  
                        $('.ql-editor').html(
                          return_data.RetCnt.replace(/&quot;/g, '"')
                            .replace(/&#x27;/g, "'")
                            .replace(/&amp;/g, /&/g)
                            .replace(/&gt;/g, '>')
                            .replace(/&lt;/g, '<')
                            .replace(/&quot;/g, /"/g)
                        );
                        this.homeText = return_data.RetCnt;
                         
                        setTimeout(() => {
                          $('.ql-editor').click(); 
                        }, 500);
                      },
                      error: function (data) {
                        swal({
                          background: '#FFFFFF',
                          title: 'Error',
                          html: `
        <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
          background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
          <div class="text-center" style="margin-top: 9%;">
            <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
            <div style="    width: 369px; height: 64px; margin-left: 39px;">
              <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                This file is restricted. Update the public access of your file from \"Restricted\" to \"Anyone with the link.\"
              </p>
            </div>
            <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
              border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
              class="mt-5 butn-alert">Ok</button>
          </div>
        </div>
      `,
                          showConfirmButton: false,
                          width: '323px',
                          timer: 4000,
                        });
  
                        setTimeout(() => {
                          const okButton =
                            document.getElementById('swal-ok-button');
                          if (okButton) {
                            okButton.addEventListener('click', () => {
                              swal.close();
                            });
                          }
                        }, 0);
                      },
                    });
                  } else if (e.docs[0].name) {
                    let filelink2 = file + fileId;
                    let linksvalue =
                      'https://docs.google.com/feeds/download/documents/export/Export?id=' +
                      fileId +
                      '&exportFormat=docx';
                    let profile_id = localStorage.getItem('profile_id');
                    $.ajax({
                      url: environment.API_URL + '/api/downloadFromDrive',
                      type: 'post',
  
                      dataType: 'json',
                      data: {
                        profile_id: profile_id,
                        hash: authResult.access_token,
                        file_path: fileId,
                        file_type: 'docx',
                        create_chunks: 'false',
                      },
                      beforeSend: function (xhr) {
                        xhr.setRequestHeader(
                          'Authorization',
                          +localStorage.getItem('token')
                        );
                      },
  
                      success: function (return_data) {
                        $('.ql-editor').html(
                          return_data.RetCnt.replace(/&quot;/g, '"')
                            .replace(/&#x27;/g, "'")
                            .replace(/&amp;/g, /&/g)
                            .replace(/&gt;/g, '>')
                            .replace(/&lt;/g, '<')
                            .replace(/&quot;/g, /"/g)
                        );
                        this.homeText = return_data.RetCnt;
                         
                        setTimeout(() => {
                          $('.ql-editor').click(); 
                        }, 500);
                      },
                      error: function (data) {
                        swal({
                          background: '#FFFFFF',
                          title: 'Error',
                          html: `
        <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
          background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
          <div class="text-center" style="margin-top: 9%;">
            <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
            <div style="    width: 369px; height: 64px; margin-left: 39px;">
              <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                This file is restricted. Update the public access of your file from \"Restricted\" to \"Anyone with the link.\"
              </p>
            </div>
            <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
              border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
              class="mt-5 butn-alert">Ok</button>
          </div>
        </div>
      `,
                          showConfirmButton: false,
                          width: '323px',
                          timer: 4000,
                        });
  
                        setTimeout(() => {
                          const okButton =
                            document.getElementById('swal-ok-button');
                          if (okButton) {
                            okButton.addEventListener('click', () => {
                              swal.close();
                            });
                          }
                        }, 0);
                      },
                    });
                  }
                }
              }
            })
            .build();
          picker.setVisible(true);
        }
      }
    }
    openDropboxChooser(): void {

        const options = {
            success: (files: any) => {
                let fileType = this.getFileType(files[0].name);

                if (fileType === 'docx' || fileType === 'pdf' || fileType === 'txt') {
                    this.uploadFileToServer(files[0].link, fileType);
                } else {
                    // console.error('Unsupported file type');
                }
            },
            cancel: () => { },
            linkType: 'direct',
            multiselect: false,
            extensions: ['.docx', '.pdf', '.txt'],
            sizeLimit: 1024 * 1024 * 5,
        };
        Dropbox.choose(options);
    }
    getFileType(fileName: string): string {
        const fileExtension = fileName.split('.').pop();
        return fileExtension ? fileExtension.toLowerCase() : '';
    }
    uploadFileToServer(fileLink: string, fileType: string): void {
        this.word_count = 0;
        this.char_count = 0;
        this.spellingmistake = 0;
        this.garmmarmistake = 0;
        this.menuafterresponse = false;
        this.showonlydrive = false;
        this.showParagraph = false;
        this.loaderAlert = true;
        const headers = new HttpHeaders({
            Authorization: environment.AuthorizationGIN,
        });
        var data = {
            file_type: fileType,
            file_path: fileLink
        };
        this.webservices.dropboxfile(fileType, fileLink).subscribe((data) => {
            let receivedData = data;
            $('.ql-editor').html(
                receivedData['RetCnt']
                    .replace(/&quot;/g, '"')
                    .replace(/&#x27;/g, "'")
                    .replace(/&amp;/g, /&/g)
                    .replace(/&gt;/g, '>')
                    .replace(/&lt;/g, '<')
                    .replace(/&quot;/g, /"/g)
            );
            this.getContent('', receivedData['RetCnt']);
            this.loaderAlert = false;
        });
    }

    onclickeditor(event: MouseEvent) {
        event.stopPropagation();
        if (this.char_count === 0 && !this.showParagraph) {
            this.word_count = 0;
            this.char_count = 0;
        }
        this.showParagraph = false;
        const sampleText = 'Enter your Text HereORUpload file from above options';
        const editorContent = $('#editor').text().trim();
        if (editorContent === sampleText) {
            this.word_count = 0;
            this.char_count = 0;
        }
        if (editorContent === '') {

            this.word_count = 0;
            this.char_count = 0;
        } else {
            this.word_count = editorContent
                .split(/\s+/)
                .filter((word) => word.length > 0).length;
        }
    }

    ngAfterViewInit(): void {

        this.char_count = $('#editor').text().length;
        this.homeText = $('#editor').text();
        this.word_count = $('#editor').text().split(/\s+/).length;


        this.checkLogin = this.webservices.isLoggedIn();
        if (this.checkLogin) {
            this.profile_id = localStorage.getItem('profile_id');

        } else {
            this.profile_id = '1';
        }
        const storedStatus = JSON.parse(
            localStorage.getItem('premium_user_done') || 'false'
        );
        this.subscribed_user = storedStatus;
        this.textfromAI();
        this.getElementHeightById('editor');
        this.getBrowserWidth();
        $(window).scroll(function () {
            if ($(this).scrollTop() > 200) {
                $('#scroll-to-top').fadeIn('slow');
            } else {
                $('#scroll-to-top').fadeOut('slow');
            }
        });
        $('#scroll-to-top').click(function () {
            $('html, body').animate({
                scrollTop: 0
            }, 700);
            return false;
        });

        this.loadLanderComponent();
    }

    toggleMenuDropdown() {
        this.isMenuDropdownVisible = !this.isMenuDropdownVisible;
    }

    selectLanguage(languageName: string, languageIcon: string) {
        this.selectedLanguage = {
            name: languageName,
            icon: languageIcon
        };
        this.isMenuDropdownVisible = false;
    }

    @ViewChild('editor') textDivRef!: ElementRef;
    deleteText() {
        $(".ql-editor").html("");
        this.loaderAlert = true;

        if (this.quill) {
            this.quill.setContents([]);

            this.homeText = '';
            this.word_count = 0;
            this.char_count = 0;

            this.showParagraph = true;
        }

        this.loaderAlert = false;
    }

    getBrowserWidth = function () {
        if (window.innerWidth <= 430) {
            this.mobilescreen = true;
            this.responseformodbile = false;
            return 'xs';
        } else if (window.innerWidth < 991) {
            this.mobilescreen = true;
            this.responseformodbile = false;
            return 'sm';
        } else if (window.innerWidth < 1199) {
            this.mobilescreen = true;
            this.responseformodbile = false;
            return 'md';
        } else {
            this.mobilescreen = false;
            this.responseformodbile = false;

            return 'lg';
        }
    };

    getContent(event, text) {
        this.copiedtext = false;
        var ctrlDown = false,
            ctrlKey = 17,
            cmdKey = 91,
            vKey = 86,
            cKey = 67;
        this.editortext = text;
        this.char_count = $('#editor').text().length;
        this.word_count = $('#editor').text().split(/\s+/).length;
        if (ctrlDown && event.keyCode == vKey) {
            this.showParagraph = false;
            var editortxt = $('#editor').text();
        }
        var editortxt = $('#editor').text();
        this.handleCheckGrammarButton()
    }
    currentTab: string = 'tab1';

    currenttoggleTab(tab: string): void {
        this.currentTab = this.currentTab === tab ? '' : tab;
    }
    getImageSrc(): string {
        switch (this.currentTab) {
            case 'tab1':
                return '../../assets/images/punctuation/Students and Teachers.png';
            case 'tab2':
                return '../../assets/images/punctuation/Creative Writers.png';
            case 'tab3':
                return '../../assets/images/punctuation/Bloggers.png';
            case 'tab4':
                return '../../assets/images/punctuation/Website Owners.png';
            default:
                return '../../assets/images/punctuation/Students and Teachers.png';
        }
    }
    getIcon(tab: string): string {
        return this.currentTab === tab ?
            '../../assets/images/free-grammarchecker/up arrow.svg' :
            '../../assets/images/free-grammarchecker/down arrow.svg';
    }

    retailerHistory = [{
        title: 'Boost Readability',
        detail: "Punctuations make it easier for readers to understand where to stress, stop, take a mini pause, etc. Therefore, correct punctuation makes it easier for readers to follow your point of view and boost your content's readability.",
    },
    {
        title: 'Enhance Professionalism',
        detail: 'It is important to fix punctuation to qualify as an industry expert. Therefore, you can make your write-ups more professional by evaluating your text for punctuation issues and applying the necessary fixes.',
    },
    {
        title: 'Guarantee Clarity',
        detail: 'The absence of necessary punctuation symbols often leads readers to need clarification. However, you can avoid such a situation and elevate the clarity of your content by reviewing and rectifying all of its punctuation errors.',
    },
    ];

    activeIndex = 0;

    setActive(index: number): void {
        this.activeIndex = index;
    }


    public saveTextRedirect() {
        $('#editor').find('span').contents().unwrap();

        this.editortxt = this.quillEditor.scroll.domNode.innerHTML;
        setTimeout(() => {
            this.quill.root.querySelectorAll("img").forEach((img) => img.remove());
          }, 0);

        if (
            this.editortxt !=
            'Upload Your ContentType or Paste AI Text hereSample TextPaste text'
        ) {
            this.char_count = $('#editor').text().length;
            this.word_count = $('#editor').text().trim().split(/\s+/).length;

            const trimmedText = this.editortxt.trim();
            if (trimmedText.length === 0) {

                this.showAlert('Error: Input is empty or only spaces.', '');

                return;
            } else {

                if (this.editortxt.length > 0) {
                    this.loaderAlert = true;
                    let data2 = JSON.stringify({
                        homeText: this.editortxt,
                        profile_id: this.profile_id,
                    });

                    let url =
                        `${environment.API_URL}/api/getNewDocIDForGuestByContents`;

                    this.webservices.postResources(data2, url).subscribe((data) => {

                        let receivedData = data;

                        this.doc_id = receivedData['new_doc_id'];

                        // this.router.navigate(['/document/', this.doc_id]);
                        this.router.navigate(['/grammar-check'], { queryParams: { doc: this.doc_id } });
                        var editortxt = '';
                        editortxt = this.homeText;
                        localStorage.setItem('editorValueAI', editortxt);
                        const url = this.router.serializeUrl(
                            this.router.createUrlTree([''])
                        );

                    });
                }
            }

        } else {
            this.showAlert('Error: Please add atleast 1 word to proceed.', '');
        }
    }
    handlePaste(event: ClipboardEvent): void {
        const clipboardData = event.clipboardData || window.clipboardData;
        const pastedData = clipboardData.getData('text/plain');

        event.preventDefault();
        document.execCommand('insertText', false, pastedData);

        this.updateWordCountPaste();
    }

    onInput(): void {
        const editableDiv = document.getElementById('editor') as HTMLElement;

        if (editableDiv) {
            const textContent = editableDiv.innerText;

            this.updateWordCountPaste();

        }
    }

    updateWordCountPaste(): void {
        const editableDiv = document.getElementById('editor') as HTMLElement;

        if (editableDiv) {
            const textContent = editableDiv.innerText;
            this.char_count = textContent.length;
            this.word_count = textContent.trim().split(/\s+/).filter(word => word.length > 0).length;


        }
    }
    captchaVisible: boolean = false;
    isCaptchaVerified: boolean = false;
    recaptchaMessage: string = '';



    handleButtonClick(): void {
        if (this.loaderAlert) {
            return;
        }
        $("#editor").find("span").contents().unwrap();
        this.char_count = $("#editor").text().length;
        this.word_count = $("#editor").text().trim().split(/\s+/).filter(word => word.length > 0).length;


        if (this.word_count === 0) {
            this.showAlert("Error: Please add at least 1 word to proceed.", "");
            return;
        }


        if (this.isCaptchaVerified) {
            this.saveTextRedirect();
        } else {
            if (!this.captchaVisible) {
                this.captchaVisible = true;
                this.cdr.detectChanges();
                this.loadAndRenderTurnstile();
            } else {
                this.recaptchaMessage = 'Please complete the CAPTCHA.';
                this.color = '#721c24';
            }
        }
    }



    showCaptchaModal(): void {
        if (!this.captchaVisible) {
            this.captchaVisible = true;
            this.cdr.detectChanges();
            this.loadAndRenderTurnstile();
        } else {
            this.recaptchaMessage = 'Please complete the CAPTCHA.';
            this.color = '#721c24';
        }
    }


    loadAndRenderTurnstile(): void {
        if (typeof window['turnstile'] === 'undefined') {
            const script = document.createElement('script');
            script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
            script.async = true;
            script.defer = true;
            script.onload = () => this.renderTurnstile();
            script.onerror = () => console.error('Failed to load Turnstile script.');
            document.body.appendChild(script);
        } else {
            this.renderTurnstile();
        }
    }

    l
    renderTurnstile(): void {
        const containerElement = document.getElementById('recaptcha-container');
        if (!containerElement) {

            return;
        }

        window['turnstile'].render(containerElement, {
            sitekey: environment.CaptchaKey,
            size: 'normal',
            callback: (token: string) => this.onTurnstileSuccess(token),
            'error-callback': () => this.onTurnstileError(),
        });

    }


    onTurnstileSuccess(token: string): void {

        this.captchaToken = token;
        this.isCaptchaVerified = true;
        this.captchaVisible = false;
        this.recaptchaMessage = '';
        this.saveTextRedirect();
    }


    onTurnstileError(): void {
        // console.error('Turnstile error occurred.');
        this.captchaToken = null;
        this.recaptchaMessage = 'CAPTCHA verification failed. Please try again.';
        this.color = '#721c24';
    }


    resetTurnstile(): void {
        const containerElement = document.getElementById('recaptcha-container');
        if (typeof window['turnstile'] !== 'undefined') {
            window['turnstile'].reset(containerElement);
            // console.log('Turnstile CAPTCHA reset.');
        } else {
            // console.error('Turnstile library not loaded.');
        }
    }


    //  objects objects objects

    executeAction(action: string) {
        if (this[action] && typeof this[action] === 'function') {
            this[action]();
        } else {
            // console.error(`Action "${action}" is not a valid method.`);
        }
    }

    contentArray = [
        {
            showParagraph: true,
            header: 'Upload Your Content',
            paragraph: 'Type or Paste AI Text here',
            buttons: [
                {
                    text: 'Sample Text',
                    icon: 'copyIcon',
                    action: 'sampletext'
                },
                {
                    text: 'Paste Text',
                    icon: 'copyIcon',
                    action: 'pasteText'
                }
            ]
        }
    ];
    contentCards = [
        {
            icon: 'PunctuationandFormattingIcon',
            title: 'Punctuation and Formatting',
            description: `The complete sentence checker identifies and corrects formatting issues that can affect the
      transparency of your writing, such as misplaced <a href="https://www.grammarin.com/what-is-a-comma"
      style="color: black; text-decoration: underline;" class=" href-style"> commas </a> or improper spacing. For visually well-organized content,
      you can also use our <a href="https://www.grammarin.com/punctuation-checker"
      style="color: black; text-decoration: underline;" class=" href-style"> punctuation checker </a>, which is specially designed for this purpose.`
        },
        {
            icon: 'syntaxOptimizationIcon',
            title: 'Syntax Optimization',
            description: `Syntax optimization improves word arrangement and makes sentences more logical and coherent.
      Therefore, our tool is designed to enhance the syntax integrity of your sentences. You can get text that is
      smoother and more understandable.`
        }
    ];
    sentenceTools = [
        {
            icon: 'grammarCorrectionIcon',
            title: 'Grammar Correction',
            description: `The sentence corrector tool detects and corrects grammatical mistakes such as subject-verb
        agreement, tense consistency, and incorrect   <a href="https://www.grammarin.com/what-are-prepositions" style="color: black; text-decoration: underline;" class=" href-style"> prepositions </a>. You can use the integrated
        <a href="https://www.grammarin.com/grammar-checker" style="color: black; text-decoration: underline;" class=" href-style">grammar checker</a>
        to fix errors according to the standard grammar rules.`
        },
        {
            icon: 'fluencySuggestionsIcon',
            title: 'Fluency Suggestions',
            description: `The sentence fixer recommends alternatives that make your sentences read more fluently by
        identifying areas where wording may be repetitive. It helps enhance readability and allows your
        writing to sound more engaging.`
        },
        {
            icon: 'easyParaphrasingIcon',
            title: 'Easy Paraphrasing',
            description: `The free sentence checker helps you avoid repetition by suggesting paraphrased text versions. It
        is valuable for those looking to add variety and creativity to their writing.`
        }
    ];
    features = [
        { name: 'checksIcon', title: 'Check', description: 'Grammar, Style, and Clarity' },
        { name: 'technologyIcon', title: 'Technology', description: 'AI-Powered' },
        { name: 'FreeIcon', title: '100% Free', description: 'Without Sign-up' },
        { name: 'unlimitedicon', title: 'Unlimited', description: 'Revisions' }
    ];
    steps = [
        { id: 1, name: 'pasteTypeIcon', text: 'Paste or type your text in the input section.' },
        { id: 2, name: 'languageSelectIcon', text: 'Select your language dialects.' },
        { id: 3, name: 'checkSentenceIcon', text: 'Click the "Check Sentence" button.' },
        { id: 4, name: 'highlightedIcon', text: 'Errors will be highlighted with suggestions.' },
        { id: 5, name: 'fixThemIcon', text: 'Fix them and download the file in seconds.' }
    ];
    dialects = [
        {
            name: 'US English',
            icon: 'USenglishIcon',
            description: 'The tool supports US English in keeping the text consistent with American linguistic regulations. It ensures your writing aligns with US standards, which is ideal for anyone writing for American audiences.'
        },
        {
            name: 'UK English',
            icon: 'UKEnglishIcon',
            description: 'For those writing in British English, the AI sentence corrector adjusts to UK-specific rules. It helps users use British English grammar correctly and make their content both authentic and accurate for a UK readership.'
        },
        {
            name: 'Canadian English',
            icon: 'CanadianEnglishIcon',
            description: 'Canadian English often blends elements of American and British English. The advanced sentence fixer is equipped to manage this unique dialect, allowing users to ensure their content is consistent with the country’s language conventions.'
        },
        {
            name: 'Australian English',
            icon: 'AustralianEnglishIcon',
            description: 'Users can also make their text accurate in Australian English dialects. It warrants that your writing aligns with the distinct rules of Australian English.'
        }
    ];
    // ----------paste method --------



    pasteText(): void {
        navigator.clipboard.read().then((clipboardItems) => {
          for (const item of clipboardItems) {
            for (const type of item.types) {
              if (type === "text/html") {
                item.getType(type).then((blob) => {
                  blob.text().then((html) => {
                    this.showParagraph = false;
    
                    const tempDiv = document.createElement("div");
                    tempDiv.innerHTML = html;
    
                    tempDiv.querySelectorAll("script").forEach((script) => script.remove());
    
                    // Remove all <img> elements
                    tempDiv.querySelectorAll("img").forEach((img) => img.remove());
                    tempDiv.querySelectorAll("video").forEach((video) => video.remove());
    
                    tempDiv.querySelectorAll("*").forEach((el) => {
                      const element = el as HTMLElement;
                      element.removeAttribute("id");
                      element.removeAttribute("class");
    
    
                      if (element.style.backgroundImage) {
                        element.style.backgroundImage = "none";
                      }
    
                      element.style.background = "none";
                      element.style.backgroundColor = "transparent";
                      element.style.color = "black";
                    });
                    const emojiRegex = /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/gu;
                    let modifiedContent = tempDiv.innerHTML.replace(emojiRegex, "");
                    // const modifiedContent = tempDiv.innerHTML;
                    if (this.quill) {
                      this.quill.clipboard.dangerouslyPasteHTML(this.quill.getSelection()?.index || 0, modifiedContent);
    
                      setTimeout(() => {
                        this.char_count = this.quill.getText().length;
                        this.word_count = this.quill.getText().trim().split(/\s+/).length;
                      }, 100);
                    }
                  });
                });
                return;
              }
            }
          }
        }).catch((err) => {
          // console.error("Failed to read clipboard contents: ", err);
        });
      }

    quill: Quill | undefined;
    onHandleFormatting(quillInstance: Quill) {
        this.quill = quillInstance;
      
        this.quill.root.addEventListener("paste", (event: ClipboardEvent) => {
          event.preventDefault(); 
      
          this.showParagraph = false;
      
          setTimeout(() => {
            let quillContent = this.quill.root.innerHTML; 
      
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = quillContent;
      
      
            tempDiv.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach((input) => input.remove());
            tempDiv.querySelectorAll("app-icons-free-tools").forEach((icon) => icon.remove());
            tempDiv.querySelectorAll("script, img, svg, video, iframe, embed").forEach((el) => el.remove());
      
      
            tempDiv.querySelectorAll("iframe").forEach((iframe) => {
              const src = (iframe as HTMLIFrameElement).src;
              if (src.includes("youtube.com") || src.includes("youtu.be")) {
                iframe.remove();
              }
            });
      
         
            tempDiv.querySelectorAll("*").forEach((el) => {
              const element = el as HTMLElement;
              element.style.background = "none";
              element.style.backgroundColor = "transparent";
              element.style.color = "black";
              element.removeAttribute("id");
              element.removeAttribute("class");
            });
      
        
            const emojiRegex = /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/gu;
            let modifiedContent = tempDiv.innerHTML.replace(emojiRegex, "").replace(/\s+/g, " ").trim();
      
          
            this.quill.setContents([]); 
            this.quill.clipboard.dangerouslyPasteHTML(0, modifiedContent);
      
            this.sanitizedContent = this.sanitizer.bypassSecurityTrustHtml(tempDiv.innerHTML);
      
            setTimeout(() => {
              this.char_count = this.quill.getText().length;
              this.word_count = this.quill.getText().trim().split(/\s+/).length;
            }, 100);
      
            this.removeImagesFromQuill();
            this.handleCheckGrammarButton();
      
            for (let i = 0; i <= 100; i += 10) {
              setTimeout(() => {
                this.quill.root.querySelectorAll('img').forEach((img) => img.remove());
              }, 5);
            }
          }, 0);
        });
      
       
      }
    
      removeImagesFromQuill() {
        setTimeout(() => {
          this.quill.root.querySelectorAll("img").forEach((img) => img.remove());
        }, 0);
      }
      sanitizedContent: SafeHtml;
      handleCheckGrammarButton() {
        if (!this.quillEditor || !this.quillEditor.root) {
          console.error("Quill editor is not initialized yet. Retrying in 100ms...");
          setTimeout(() => this.handleCheckGrammarButton(), 100); 
          return;
        }
      
      
        this.quillEditor.root.querySelectorAll("img").forEach((img) => img.remove());
      
        setTimeout(() => {
          if (this.quillEditor.root.innerText.trim().length === 0) {
            this.quillEditor.root.querySelectorAll("img").forEach((img) => img.remove());
            this.quillEditor.enable();
          }
        }, 0);
      }
    quillEditor: any;
    onEditorCreated(quillInstance: Quill) {
        this.quillEditor = quillInstance;
      
        this.quillEditor.on('text-change', (delta, oldDelta, source) => {
          if (source === 'user') {  
            this.updateEditorContent();
          }
        });
      
        this.updateEditorContent();
      }
      updateEditorContent() {
        if (!this.quillEditor) return;
      
        this.homeText = this.quillEditor.root.innerHTML;
        this.char_count = this.quillEditor.getText().trim().length;
        this.word_count = this.quillEditor.getText().trim().split(/\s+/).filter(word => word.length > 0).length;
      
      
      }
    // Custom toolbar configuration

    editorModules = {
        toolbar: false
        //  [
        // ['bold', 'italic', 'underline'], // Text styling options
        // [{ list: 'ordered' }, { list: 'bullet' }], // Lists
        // [{ header: [1, 2, 3, false] }], // Header levels
        // ['link'], // Links

        // ],
    };

    // ----------paste method --------
      count_Words_Character2() {
    
        this.char_count = this.quillEditor.getText().trim().length;
        this.word_count = this.quillEditor
          .getText()
          .trim()
          .split(/\s+/)
          .filter((word) => word.length > 0).length;
          this.char_count = $('.ql-editor').text().length;
          this.word_count = $('.ql-editor').text().split(/\s+/).length;
      }

      @ViewChild('landerContainer', { read: ViewContainerRef, static: false }) landerContainer!: ViewContainerRef;
      landerComponentRef: ComponentRef<any> | null = null;
      isLanderLoaded = false;

      async loadLanderComponent() {
        if (this.isLanderLoaded || !this.landerContainer) return;
        const { LanderComponent } = await import('../grammarchecker/additional/lander.component');
        this.landerComponentRef = this.landerContainer.createComponent(LanderComponent);
        this.landerComponentRef.instance.toolName = "Sentence";
        this.isLanderLoaded = true;
      }
}
